import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';
import { OnDestroyHookDirective } from 'src/app/shared/hooks';

@Component({
  selector: 'mprd-public-wifi-pxsplus-hotspot',
  templateUrl: './public-wifi-pxsplus-hotspot.component.html',
  styleUrls: ['./public-wifi-pxsplus-hotspot.component.css'],
})
export class PublicWifiPxsplusHotspotComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  @Input() configureUrl: string;
  backUrlFromApp: string;

  constructor(
    private inceptionService: InceptionService,
    private translationService: TranslationService,
  ) {
    super();
  }

  ngOnInit() {
    if (window['MyProximusMobileApp']) {
      this.backUrlFromApp = this.translationService.getTranslatedValueFor(
        'common.myproximus.back.url',
      );
    }

    setTimeout(() => {
      this.inceptionService.init();
    });
  }

  sendConfigureUrl() {
    window.ReactNativeWebView.postMessage(this.configureUrl);
  }

  goBack() {
    this.backUrlFromApp
      ? window.open(this.backUrlFromApp)
      : window.history.back();
  }
}
